import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './i18n'
import './styles/style.scss'
import './styles/theme.scss'
import App from './App'
import { Provider } from 'react-redux'
import { store } from 'store/index'
import AppThemeProvider from './styles/AppThemeProvider'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <AppThemeProvider>
          <App />
        </AppThemeProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>,
)

// --- Service worker registration (PWA) ---
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('SW registration failed:', err)
      })
  })
}

// --- Apply persisted theme (light/dark) before first paint ---
try {
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme === 'dark' || savedTheme === 'light') {
    document.documentElement.setAttribute('data-theme', savedTheme)
  }
} catch (_) {
  /* ignore */
}

// --- Swallow uncaught axios errors (so the dev overlay doesn't pop on
// every 404 from a stale endpoint). Logs to console for debugging.
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  if (reason && reason.isAxiosError) {
    // eslint-disable-next-line no-console
    console.warn(
      '[axios]',
      reason.config?.method?.toUpperCase(),
      reason.config?.url,
      '→',
      reason.response?.status,
      reason.response?.data,
    )
    event.preventDefault()
  }
})
